import { render, staticRenderFns } from "./newWareHouse.vue?vue&type=template&id=71c7d026&scoped=true&name=warehouse&"
import script from "./newWareHouse.vue?vue&type=script&lang=js&"
export * from "./newWareHouse.vue?vue&type=script&lang=js&"
import style0 from "./newWareHouse.vue?vue&type=style&index=0&id=71c7d026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7d026",
  null
  
)

export default component.exports